import { computed, effect, Injectable } from "@angular/core";
import { CorpForm } from "@corporate-tailwind/corp-form";
import { CurrencyPurchaseDto, CurrencyPurchaseSchema } from "../model/currency-purchase.model";
import { CurrencyPurchaseSelectionState } from "../state/currency-purchase.selection.state";
import { CurrencyPurchaseState } from "../state/currency-purchase.state";
import { CorpTranslateService } from "@corporate-tailwind/translation";
import { SessionService } from "src/app/shared/session/session-service";
import { Router } from "@angular/router";
import { debounceTime, startWith, filter } from "rxjs";
import { CurrencyDirection } from "src/app/features/pages/order/model/order-currency-direction.model";
import { OrderApprovalRangeState } from "../state/order-approval-range.state";

@Injectable({ providedIn: 'root' })
export class CurrencyPurchaseService extends CorpForm<CurrencyPurchaseDto> {
    private previousValue!: CurrencyPurchaseDto;
    
    selection$ = computed(() => {
        this._corpTranslateService.lang$(); // dépendance langue
        return this._corpTranslateService.translate(
            this._selectionState.selection()
        );
    });

    currencyPurchase$ = computed(() => this._state.currencyPurchase());
    loading$ = computed(() => this._state.loading());
    loadingCurrencyValue$ = this._state.loadingCurrencyValue;
    isAmountAlert$ = this._state.isAmountAlert;
    orderApprovalRange$ = computed(() => this._orderApprovalRangeState.selection());
    loadingCurrency$ = computed(() => this._selectionState.loadingCurrency());

    constructor(
        public _selectionState: CurrencyPurchaseSelectionState,
        public _orderApprovalRangeState: OrderApprovalRangeState,
        public _state: CurrencyPurchaseState,
        private _corpTranslateService: CorpTranslateService,
        private _sessionService: SessionService,
        private _router: Router
    ) {
        super(CurrencyPurchaseSchema, CurrencyPurchaseSchema)

        // 🔄 synchroniser le signal -> form
        var effectSignal = effect(() => {
            const currencyPurchase = this._state.currencyPurchase();
            if (!currencyPurchase) return;

            this.safePatchValue(currencyPurchase);
            this.previousValue = currencyPurchase;

            if(this.onInit) {
                this.initFormChange();
                this.onInit = false;
            }
        });
    }

    initFormChange() {
        this.previousValue = this.formGroup.getRawValue();
            
        // 🔄 synchroniser le form -> signal (normalement dans ngonInit)
        var valueChangeFormGroup = this.formGroup?.valueChanges
            .pipe(
                startWith(this.formGroup.value),
                filter(() => !this.isPatching),
                debounceTime(50)
                )
            .subscribe((current) => {
                // console.log('changes-current', current);
                const changes = this.getDiff(this.previousValue, current);
                // console.log('changes-changes', changes);
                if(changes){
                    if (changes?.sourceAmount != null) {
                        // console.log('SourceToTarget changes', `${this.previousValue.sourceAmount} | ${current.sourceAmount}`);
                        // this.setValue(x=>x.direction, CurrencyDirection.SourceToTarget);
                        current.direction = CurrencyDirection.SourceToTarget;
                        this._state.changeItem(current);
                    }

                    if (changes?.targetAmount != null) {
                        // console.log('TargetToSource changes', `${previous.targetAmount} | ${current.targetAmount}`);
                        // this.setValue(x=>x.direction, CurrencyDirection.TargetToSource);
                        current.direction=CurrencyDirection.TargetToSource;
                        this._state.changeItem(current);
                    }

                    if(changes?.targetCurrency != null) {
                        if(changes?.targetCurrency?.code != null) {
                            // console.log('currency changes', `${previous.targetCurrency.code} | ${current.targetCurrency.code}`);
                            // console.log('current', current);
                            this._state.changeItem(current);
                        }
                    }
                    this._state.patch(current);
                    this.previousValue = structuredClone(current);
                }

                
        });
    }

    init(): void {
        this._state.init();
    }

}